// import React, { useState, useEffect } from "react";
// import { BASE_URL } from "../../config/axios"
// import axios from "axios";
// import { formattedDateLong } from "../Date";
// import { ToastContainer, toast } from "react-toastify";
// import { handleErrorToast } from "../CustomFunctions";

// const Personaldetails = ({ email, emp_code }) => {
//   const [formData, setFormData] = useState({})

//   const [edudata, setEduData] = useState([])
//   const [workData, setWorkData] = useState([])
//   const [emgData, setemgData] = useState([])
//   const [perData, setPerData] = useState([])
//   const [buffer, setBuffering] = useState(true); //buffering logic


//   useEffect(() => {

//     const getUSerDetails = async (email, emp_code) => {
//       setBuffering(true); // Start Buffering
//       try {
//         const res = await axios.get(`${BASE_URL}/userdata/userdataget/${email}/`);

//         const resedu = await axios.get(`${BASE_URL}/userdata/EmployeeEducationDetailsallget/${email}/`);

//         const work = await axios.get(`${BASE_URL}/userdata/userworkexpallget/${email}/`);
//         const Emg = await axios.get(`${BASE_URL}/userdata/userEmergencyContactallget/${email}/`);
//         const per = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${emp_code}/`);

//         setFormData(res.data);
//         setEduData(resedu.data);
//         setWorkData(work.data)
//         setemgData(Emg.data)
//         setPerData(per.data)

//       } catch (err) {
//         // alert(err.message);

//         handleErrorToast(err)
//       } finally {
//         setBuffering(false);// End Buffering
//       }

//     };

//     getUSerDetails(email, emp_code);
//   }, [email, emp_code]);






//   return (
//     <div>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//       {/* {buffer ? <div className="spinner-z"></div> : null} */}
//       <div className="main-div-personaldetial">
//         <div className="presonal-info">
//           <div className="personal-detail">
//             <h3 className="personal-detail-heading   font-weight500  font-size-heading">Primary Details</h3>
//             {buffer ? <div className="spinner-small"></div> :
//               <table>
//                 <tr>
//                   <td className="personal-detail-1   font-weight500  font-size-text ">Name</td>
//                   <th className="personal-detail-2   font-weight500  font-size-text ">{formData.name}</th>
//                 </tr>
//                 <tr>
//                   <td className="personal-detail-1   font-weight500  font-size-text ">Marital Status</td>
//                   <th className="personal-detail-2   font-weight500  font-size-text ">{formData.married_status}</th>
//                 </tr>
//                 <tr>
//                   <td className="personal-detail-1   font-weight500  font-size-text ">Date of Birth</td>
//                   <th className="personal-detail-2   font-weight500  font-size-text ">{formData.dob ? formattedDateLong(formData.dob) : null}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1   font-weight500  font-size-text ">Blood Group</td>
//                   <th className="personal-detail-2   font-weight500  font-size-text ">{formData.blood_group}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1   font-weight500  font-size-text ">Birth Mark</td>
//                   <th className="personal-detail-2   font-weight500  font-size-text ">{formData.birth_mark}</th>
//                 </tr >

//               </table >
//             }
//           </div >

//           <div className="contact-details">
//             <h3 className="personal-detail-heading   font-weight500  font-size-heading">Offical Details</h3>
//             {buffer ? <div className="spinner-small"></div> :
//               <>
//                 < tr >
//                   <td className="personal-detail-1   font-weight500  font-size-text ">Designation</td>
//                   <th className="personal-detail-2   font-weight500  font-size-text ">{perData.designation_name} </th>
//                 </tr>
//                 <tr>
//                   <td className="personal-detail-1   font-weight500  font-size-text ">Empolyee Role</td>
//                   <th className="personal-detail-2   font-weight500  font-size-text ">{perData.employee_type}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1   font-weight500  font-size-text ">Joining Date</td>
//                   <th className="personal-detail-2   font-weight500  font-size-text ">{formattedDateLong(perData.joining_date)}</th>
//                 </tr >
//               </>
//             }
//           </div >
//         </div >

//         <div className="address-details">
//           <h3 className="personal-detail-heading   font-weight500  font-size-heading">Address Details</h3>
//           {buffer ? <div className="spinner-small"></div> :
//             <div className="address-details-1 ">
//               <div className="current-address font-weight400 -margin">
//                 <span className="current-address font-weight400  ">
//                   <h5 className="font-size-subheading">Current Address</h5>
//                   <p className="font-size-text font-weight500">
//                     {formData.current_address}
//                   </p>
//                 </span>
//               </div>
//               <div>
//                 <span className="current-address font-weight400 ">
//                   <h5 className="font-size-subheading">Permanent Address</h5>
//                   <p className="font-size-text font-weight500">
//                     {formData.permanent_address}
//                   </p>
//                 </span>
//               </div>
//             </div>
//           }
//         </div>

//         <div className="Education-details">
//           <h3 className="personal-detail-heading   font-weight500  font-size-heading">Education Details</h3>
//           {buffer ? <div className="spinner-small"></div> :
//             <div className="education-info">
//               {edudata
//                 .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
//                 .map((e, index) => {
//                   return (
//                     <div className="education-info-1">
//                       <h3 className="experiance-details  font-weight500  font-size-subheading  ">Education Details {index + 1}</h3>
//                       <table>
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">College</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{e.college}</th>
//                         </tr>
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">Course</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{e.department}</th>
//                         </tr>
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">Grade</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{e.grade}</th>
//                         </tr >
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">From Year</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{formattedDateLong(e.startDate)}</th>
//                         </tr >
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">End Year</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{formattedDateLong(e.endDate)}</th>
//                         </tr >
//                       </table >
//                     </div >
//                   )
//                 })}


//             </div >}
//         </div >

//         <div className="Education-details Experience Detials">
//           <h3 className="personal-detail-heading   font-weight500  font-size-heading">Experience Details</h3>
//           {buffer ? <div className="spinner-small"></div> :
//             <div className="education-info">
//               {workData
//                 .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
//                 .map((a, index) => {
//                   return (
//                     <div className="education-info-1">
//                       <h3 className="experiance-details  font-weight500  font-size-subheading  ">Company {index + 1}</h3>
//                       <table>
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">Company Name</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{a.company}</th>
//                         </tr>
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">Designation</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{a.jobposition}</th>
//                         </tr>
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">Job position</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{a.jobtype}</th>
//                         </tr >
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">Duration</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{formattedDateLong(a.startDate)}
//                             {' '} to < br /> {formattedDateLong(a.endDate)}</th >
//                         </tr >
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">Monthly CTC</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text "> {a.monthlyCtc}</th>
//                         </tr >
//                         <tr>
//                           <td className="personal-detail-1   font-weight500  font-size-text ">Monthly in hand</td>
//                           <th className="personal-detail-2   font-weight500  font-size-text ">{a.monthlyInhand}</th>
//                         </tr >
//                       </table >
//                     </div >
//                   )
//                 })}
//             </div >
//           }
//         </div >

//         <div className="Education-details Experience Detials">
//           <h3 className="personal-detail-heading   font-weight500  font-size-heading">Emergency Details</h3>
//           {buffer ? <div className="spinner-small"></div> :
//             <div className="education-info">
//               {emgData.map((a, index) => {
//                 return (
//                   <div className="education-info-1">
//                     <h3 className="experiance-details  font-weight500  font-size-subheading  ">Contact Person Detail {index + 1}</h3>
//                     <table>
//                       <tr>
//                         <td className="personal-detail-1   font-weight500  font-size-text ">Name</td>
//                         <th className="personal-detail-2   font-weight500  font-size-text ">{a.person_name}</th>
//                       </tr>
//                       <tr>
//                         <td className="personal-detail-1   font-weight500  font-size-text ">Relation</td>
//                         <th className="personal-detail-2   font-weight500  font-size-text ">{a.relation}</th>
//                       </tr>
//                       <tr>
//                         <td className="personal-detail-1   font-weight500  font-size-text ">Number</td>
//                         <th className="personal-detail-2   font-weight500  font-size-text ">{a.phone_number}</th>
//                       </tr >
//                     </table >
//                   </div >
//                 )
//               })}
//             </div >
//           }
//         </div >
//       </div >
//     </div >
//   );
// };

// export default Personaldetails;


import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import { formattedDateLong } from "../Date";
import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast } from "../CustomFunctions";
import { UserProfileIcon, Location, OfficeBagIcon, EducationIcon, CallIcon, ChevronUPDownIcon } from "../AllSvg";

// --- REUSABLE UI COMPONENTS ---

const SectionCard = ({ title, iconSvg, children, defaultOpen = true, buffer }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="pd-section-card">
      <div
        className={`pd-section-header ${isOpen ? 'is-open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="pd-header-left">
          <div className={`pd-icon-box`}>
            {iconSvg}
          </div>
          <h3 className="pd-section-title">{title}</h3>
        </div>
          <ChevronUPDownIcon direction={isOpen ? 'up' : 'down'} color="#2576bc"/>        
      </div>

      {isOpen && (
        <div className="pd-section-content">
          {buffer ? <div className="spinner-small" style={{ margin: 'auto' }}></div> : children}
        </div>
      )}
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div className="pd-info-row">
    <span className="pd-info-label">{label}</span>
    <span className="pd-info-value">{value || "-"}</span>
  </div>
);

const Personaldetails = ({ email, emp_code }) => {
  const [formData, setFormData] = useState({});
  const [edudata, setEduData] = useState([]);
  const [workData, setWorkData] = useState([]);
  const [emgData, setemgData] = useState([]);
  const [perData, setPerData] = useState({});
  const [buffer, setBuffering] = useState(true);

  useEffect(() => {
    const getUSerDetails = async (email, emp_code) => {
      setBuffering(true);
      try {
        const res = await axios.get(`${BASE_URL}/userdata/userdataget/${email}/`);
        const resedu = await axios.get(`${BASE_URL}/userdata/EmployeeEducationDetailsallget/${email}/`);
        const work = await axios.get(`${BASE_URL}/userdata/userworkexpallget/${email}/`);
        const Emg = await axios.get(`${BASE_URL}/userdata/userEmergencyContactallget/${email}/`);
        const per = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${emp_code}/`);

        setFormData(res.data);
        setEduData(resedu.data);
        setWorkData(work.data);
        setemgData(Emg.data);
        setPerData(per.data);
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setBuffering(false);
      }
    };
    getUSerDetails(email, emp_code);
  }, [email, emp_code]);

  return (
    <div className="personal-details-wrapper">
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      {/* 1. PERSONAL INFORMATION */}
      <SectionCard title="Personal Information" iconSvg={<UserProfileIcon color="rgb(37, 118, 188)" />} buffer={buffer}>
        <div className="pd-grid-2-col">
          <div>
            <InfoRow label="Full Name" value={formData.name} />
            <InfoRow label="Marital Status" value={formData.married_status} />
            <InfoRow label="Date of Birth" value={formData.dob ? formattedDateLong(formData.dob) : null} />
            <InfoRow label="Blood Group" value={formData.blood_group} />
            <InfoRow label="Birth Mark" value={formData.birth_mark} />
          </div>
          <div>
            <h4 className="pd-sub-heading">Official Details</h4>
            <InfoRow label="Designation" value={perData.designation_name} />
            <InfoRow label="Employee Role" value={perData.employee_type} />
            <InfoRow label="Joining Date" value={perData.joining_date ? formattedDateLong(perData.joining_date) : null} />
          </div>
        </div>
      </SectionCard>

      {/* 2. ADDRESS INFORMATION */}
      <SectionCard title="Address Information" iconSvg={<Location color="rgb(37, 118, 188)" />} buffer={buffer}>
        <div className="pd-grid-address">
          <div>
            <span className="pd-contact-label">Current Address</span>
            <p className="pd-info-value" style={{ margin: 0, lineHeight: 1.5 }}>{formData.current_address || "-"}</p>
          </div>
          <div>
            <span className="pd-contact-label">Permanent Address</span>
            <p className="pd-info-value" style={{ margin: 0, lineHeight: 1.5 }}>{formData.permanent_address || "-"}</p>
          </div>
        </div>
      </SectionCard>

      {/* 3. EDUCATION DETAILS */}
      <SectionCard title="Education Details" iconSvg={<EducationIcon color="rgb(37, 118, 188)" />} buffer={buffer}>
        {edudata.sort((a, b) => new Date(a.startDate) - new Date(b.startDate)).map((e, index) => (
          <div key={index} className="pd-timeline-item">
            <div className="pd-timeline-dot"></div>

            <div className="pd-timeline-content">
              <div>
                <h4 className="pd-timeline-title">{e.college}</h4>
                <span className="pd-timeline-subtitle">{e.department}</span>
              </div>
              <div>
                <span className="pd-contact-label">Grade</span>
                <span className="pd-contact-value">{e.grade}</span>
              </div>
              <div>
                <span className="pd-contact-label">From</span>
                <span className="pd-contact-value">{e.startDate ? formattedDateLong(e.startDate) : "-"}</span>
              </div>
              <div>
                <span className="pd-contact-label">To</span>
                <span className="pd-contact-value">{e.endDate ? formattedDateLong(e.endDate) : "-"}</span>
              </div>
            </div>
          </div>
        ))}
        {edudata.length === 0 && <span className="pd-empty-state">No education details found.</span>}
      </SectionCard>

      {/* 4. EXPERIENCE DETAILS */}
      <SectionCard title="Experience Details" iconSvg={<OfficeBagIcon color="rgb(37, 118, 188)" />} buffer={buffer}>
        {workData.sort((a, b) => new Date(a.startDate) - new Date(b.startDate)).map((a, index) => (
          <div key={index} className="pd-timeline-item">
            <div className="pd-timeline-dot"></div>

            <div className="pd-timeline-content">
              <div>
                <h4 className="pd-timeline-title">{a.company}</h4>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="pd-timeline-subtitle">{a.jobposition}</span>
                  {a.jobtype && <span className="pd-tag">{a.jobtype}</span>}
                </div>
              </div>
              <div>
                <span className="pd-contact-label">Duration</span>
                <span className="pd-contact-value">
                  {a.startDate ? formattedDateLong(a.startDate) : "-"} - {a.endDate ? formattedDateLong(a.endDate) : "-"}
                </span>
              </div>
              <div>
                <span className="pd-contact-label">Monthly CTC</span>
                <span className="pd-contact-value">{a.monthlyCtc || "-"}</span>
              </div>
              <div>
                <span className="pd-contact-label">Monthly In Hand</span>
                <span className="pd-contact-value">{a.monthlyInhand || "-"}</span>
              </div>
            </div>
          </div>
        ))}
        {workData.length === 0 && <span className="pd-empty-state">No experience details found.</span>}
      </SectionCard>

      {/* 5. EMERGENCY CONTACT */}
      <SectionCard title="Emergency Contact" iconSvg={<CallIcon color="rgb(37, 118, 188)" />} buffer={buffer}>
        {emgData.map((a, index) => (
          <div key={index} className="pd-contact-grid">
            <div>
              <span className="pd-contact-label">Name</span>
              <span className="pd-contact-value" style={{ fontWeight: 600 }}>{a.person_name}</span>
            </div>
            <div>
              <span className="pd-contact-label">Relation</span>
              <span className="pd-contact-value">{a.relation}</span>
            </div>
            <div>
              <span className="pd-contact-label">Phone Number</span>
              <span className="pd-contact-value">{a.phone_number}</span>
            </div>
          </div>
        ))}
        
        {emgData.length === 0 && <span className="pd-empty-state">No emergency contacts found.</span>}
      </SectionCard>

    </div>
  );
};

export default Personaldetails;